<template>
  <div>
    <h3 class="greenTitle">Configuración de ordenes</h3>
    <div class="firstStep">
      <el-form>
        <el-form-item label="Tipos de documentos">
          <el-select
            v-model="stepData.document_types_id"
            placeholder="Ej: F12, F11"
            filterable
            multiple
            clearable>
            <el-option  v-for="document in data.documents"
                        :key="document.id"
                        :label="document.type"
                        :value="document.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="Tamaño de paquetes">
          <el-select  v-model="stepData.package_types_id"
                      placeholder="Ej: BT, MT, MMT"
                      filterable
                      multiple
                      clearable>
            <el-option  v-for="packageType in data.packages"
                        :key="packageType.id"
                        :label="packageType.type"
                        :value="packageType.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="Tipo de viaje">
          <el-select  v-model="stepData.travel_types_id"
                      placeholder="Ej: PPF"
                      filterable
                      clearable>
            <el-option  v-for="travelType in data.travels"
                        :key="travelType.id"
                        :label="travelType.type"
                        :value="travelType.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="ctt" v-if="stepData.travel_types_id === 9">
          <el-select  v-model="stepData.transfer_centers_id"
                      placeholder="Ej: Tradis"
                      filterable
                      clearable>
            <el-option  v-for="ctt in data.ctts"
                        :key="ctt.id"
                        :label="ctt.name"
                        :value="ctt.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="Rango horario">
          <el-select  v-model="stepData.time_windows_tags_id"
                      placeholder="Ej: Fecha Programada"
                      filterable
                      multiple
                      clearable>
            <el-option  v-for="twt in data.time_windows_tags"
                        :key="twt.id"
                        :label="twt.name"
                        :value="twt.id"/>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="buttonsContainer">
      <el-button  class="flat"
                  @click="handlePrevStep()">
                  ANTERIOR
      </el-button>
      <el-button  class="default"
                  @click="handleNextStep()">
                  SIGUIENTE
      </el-button>
    </div>
  </div>
</template>

<script>
import { cachedAPIRequest } from '../../mixins/cacheDim';

export default {
  props: {
    stepData: {
      type: Object,
    },
    stepFullData: {
      type: Object,
    },
  },
  data() {
    return {
      dataToCheck: {
        document_types_id: [],
        package_types_id: [],
        delivery_methods_id: [],
        time_windows_tags_id: [],
        travel_types_id: '',
        transfer_centers_id: '',
      },
      data: {
        documents: [],
        packages: [],
        delivery_methods: [],
        time_windows_tags: [],
        travels: [],
        ctts: [],
      },
      fullStepData: {
        config: {
          enterprises_id: [],
          enterprises_name: [],
          distribution_centers_id: [],
          distribution_centers_name: [],
          region: 0,
          region_name: '',
          communes_id: [],
          communes_name: [],
          time_init: '',
          time_finish: '',
          document_types_id: [],
          document_types_name: [],
          package_types_id: [],
          package_types_name: [],
          delivery_methods_id: [],
          delivery_methods_name: [],
          time_windows_tags_id: [],
          time_windows_tags_name: [],
          travel_types_id: '',
          travel_types_name: '',
          transfer_centers_id: '',
          transfer_centers_name: '',
        },
      },
    };
  },
  methods: {
    handlePrevStep() {
      this.$emit('step', 0);
    },
    setDataToCheck() {
      const thisStepData = this.stepData;
      this.dataToCheck.package_types_id.length = 0;
      thisStepData.package_types_id.forEach((chosenPackage) => {
        const equalpackage = this.data.packages.find(element => element.id === chosenPackage);
        this.dataToCheck.package_types_id.push(equalpackage.type);
        this.fullStepData.config.package_types_id.push(equalpackage.id);
        this.fullStepData.config.package_types_name.push(equalpackage.type);
      });
      this.dataToCheck.document_types_id.length = 0;
      thisStepData.document_types_id.forEach((chosenDocument) => {
        const equalDocument = this.data.documents.find(element => element.id === chosenDocument);
        this.dataToCheck.document_types_id.push(equalDocument.type);
        this.fullStepData.config.document_types_id.push(equalDocument.id);
        this.fullStepData.config.document_types_name.push(equalDocument.type);
      });
      // timeWindowsTags
      this.dataToCheck.time_windows_tags_id.length = 0;
      thisStepData.time_windows_tags_id.forEach((chosenTimeWindowTag) => {
        // eslint-disable-next-line max-len
        const equalTimeWindowsTags = this.data.time_windows_tags.find(e => e.id === chosenTimeWindowTag);
        this.dataToCheck.time_windows_tags_id.push(equalTimeWindowsTags.name);
        this.fullStepData.config.time_windows_tags_id.push(equalTimeWindowsTags.id);
        this.fullStepData.config.time_windows_tags_name.push(equalTimeWindowsTags.name);
      });
      const equalTravelType = this.data.travels
        .find(element => element.id === thisStepData.travel_types_id);
      this.dataToCheck.travel_types_id = equalTravelType.type;
      this.fullStepData.config.travel_types_id = equalTravelType.id;
      this.fullStepData.config.travel_types_name = equalTravelType.type;
    },
    handleNextStep() {
      this.setDataToCheck();
      const dataToCheck = this.stepData;
      if (dataToCheck.package_types_id.length > 0
        && dataToCheck.travel_types_id !== ''
        && dataToCheck.document_types_id.length > 0) {
        this.$emit('submitFilter');
        this.$emit('handleDataListToCheck', this.dataToCheck, this.fullStepData);
        this.$emit('step', 2);
      } else {
        this.$notify.warning({
          title: '¡Cuidado!',
          message: 'Dejar campos vacíos puede afectar tu planificación',
        });
      }
    },
    getDocumentTypes() {
      cachedAPIRequest({
        module: 'planning',
        service: 'document_type',
        params: { limit: 20 },
      }).then((data) => {
        this.data.documents = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Problemas al cargar los tipos de documentos',
        });
      });
    },
    getPackagesTypes() {
      cachedAPIRequest({
        module: 'planning',
        service: 'package_types',
        params: { limit: 1000 },
      }).then((data) => {
        this.data.packages = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Problemas a cargar los tipos de paquetes',
        });
      });
    },
    getTravelTypes() {
      cachedAPIRequest({
        module: 'planning',
        service: 'travel_types',
        params: { limit: 1000 },
      }).then((data) => {
        this.data.travels = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Problemas al cargar los métodos de envío',
        });
      });
    },
    getDeliveryMethods() {
      cachedAPIRequest({
        module: 'crud',
        service: 'delivery_methods',
        params: { limit: 1000 },
      }).then((data) => {
        this.data.delivery_methods = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Problemas al cargar los tipos de viajes',
        });
      });
    },
    getTimeWindowsTags() {
      cachedAPIRequest({
        module: 'crud',
        service: 'get_time_windows_tags',
        params: { limit: 1000 },
      }).then((data) => {
        this.data.time_windows_tags = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Problemas al obtener las ventanas horaras',
        });
      });
    },
    getTransferCenterTypes() {
      cachedAPIRequest({
        module: 'planning',
        service: 'transfer_center',
        params: { limit: 1000 },
      }).then((data) => {
        this.data.ctts = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Problemas al cargar los CTTs',
        });
      });
    },
    getFullData() {
      const data = this.stepFullData.config;
      this.fullStepData.config.enterprises_id = data.enterprises_id;
      this.fullStepData.config.enterprises_name = data.enterprises_name;
      this.fullStepData.config.distribution_centers_id = data.distribution_centers_id;
      this.fullStepData.config.distribution_centers_name = data.distribution_centers_name;
      this.fullStepData.config.region = data.region;
      this.fullStepData.config.region_name = data.region_name;
      this.fullStepData.config.communes_id = data.communes_id;
      this.fullStepData.config.communes_name = data.communes_name;
      this.fullStepData.config.time_init = data.time_init;
      this.fullStepData.config.time_finish = data.time_finish;
      this.fullStepData.config.delivery_methods = data.delivery_methods;
    },
  },
  beforeMount() {
    // TODO algo
    this.getFullData();
    this.getDocumentTypes();
    this.getPackagesTypes();
    this.getTravelTypes();
    this.getDeliveryMethods();
    this.getTimeWindowsTags();
    this.getTransferCenterTypes();
  },
};

</script>
<style lang="scss" scoped>
.stepsMaxWidth {
  max-width: 90%;
}
.stepContainerStyle {
  // max-height: 600px;
  // overflow: scroll;
  width: 90%;
  border: 1px solid #E0E0E0;
  margin-top: 1em;
  padding: 1.5em;
  box-sizing: border-box;
}
.timePickerStyle {
  display: flex;
  width: 100%;
  margin-bottom: 22px;
  justify-content: space-between;
  .timePicker {
    width: 48.5%;
  }
}
.buttonsContainer {
  display: flex;
  justify-content: space-between;
}
.el-form {
  display: flex;
  flex-direction: column;
}
.el-form-item {
  position: relative;
}
.label {
  text-transform: uppercase;
  font-size: 10px;
  color: #606266;
  margin-bottom: 8px;
}
.greenTitle{
  font-size: 15px;
  color: #AAD500;
  margin: 0;
  text-align: left;
  font-weight: 900;
  text-transform: uppercase;
  margin-bottom: 20px;
}
.redTitle{
  font-size: 15px;
  color: orange;
  margin: 0;
  text-align: left;
  font-weight: 900;
  text-transform: uppercase;
  margin-bottom: 2px;
}
span.subtitle {
  &:before {
    font-size: 12px;
    content: "*";
  }
  font-size: 12px;
  color: #606266;
  margin: 0;
  text-align: left;
  margin-bottom: 15px;
}
.greySubTitle{
  color: #707070;
  font-weight: 300;
  text-align: left;
  font-size: 14px;
  margin: 0 0 1em;
}
</style>
